import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Auto3dView({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '1.5',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 25 25' {...props}>
      <Path
        d='M6.89453 10.4438C7.10673 9.70978 7.75534 9.1626 8.55743
           9.1626C9.52902 9.1626 10.3178 9.95001 10.3178 10.9229C10.3178
            11.7931 9.61176 12.4991 8.74161 12.4991C9.61176 12.4991 10.3178
             13.2051 10.3178 14.0752C10.3178 15.0468 9.53035 15.8356
              8.55743 15.8356C7.75534 15.8356 7.10673 15.2884 6.89453 14.5543'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M15.5367 15.8356H13.6562V9.1626H15.5367C16.9554 9.1626
           18.1058 10.313 18.1058 11.7317V13.2678C18.1044 14.6851 16.9554
            15.8356 15.5367 15.8356V15.8356Z'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <Path
        d='M9.98291 3.88321L8.01172 1.91069C12.1997 0.138349 17.2217
           0.951116 20.6343 4.365C24.7822 8.51291 25.0918 15.0351 21.5805
            19.5473'
        stroke={color}
        fill={fill}
        strokeWidth={strokeWidth}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <Path
        d='M3.41786 5.45166C-0.0921132 9.96525 0.216178 16.4874
           4.36409 20.634C7.77664 24.0465 12.7987 24.8606 16.9867
            23.0883L15.0141 21.1158'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </IconBase>
  )
}

Auto3dView.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.string,
}

export default Auto3dView
